import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import meme1 from "../media/meme-1.png";
import meme2 from "../media/meme-2.png";
import meme3 from "../media/meme-3.png";
import meme4 from "../media/meme-4.png";
import meme5 from "../media/meme-5.png";
import meme6 from "../media/meme-6.png";

const memes = [
    meme1,
    meme2,
    meme3,
    meme4,
    meme5,
    meme6,
];

function MemeGallery() {

    return (

        <section className="meme-gallery" id="memes">

            <div className="container">

                <div className="section-title">

                    <h2>MEME GALLERY</h2>

                </div>

                <Swiper
                    modules={[Autoplay, Pagination]}
                    loop={true}
                    speed={700}
                    spaceBetween={25}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    breakpoints={{
                        0: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 3,
                        },
                        1200: {
                            slidesPerView: 6,
                        },
                    }}
                >

                    {memes.map((image, index) => (

                        <SwiperSlide key={index}>

                            <div className="meme-card">

                                <img
                                    src={image}
                                    alt={`Meme ${index + 1}`}
                                    className="img-fluid"
                                />

                            </div>

                        </SwiperSlide>

                    ))}

                </Swiper>

            </div>

        </section>

    );

}

export default MemeGallery;